<template>
  <div v-click-outside="closeDropdown" style="position: relative">
    <div :class="{ active: buttonActive }" class="dropdown-btn" @click="manageButton()">
      <div class="text">
        {{ dataText }}
      </div>
      <i class="mdi mdi-chevron-down"></i>
    </div>
    <div :class="{ active: buttonActive }" class="dropdown-choices">
      <div
        v-for="(option, index) in options"
        :key="index"
        :class="{ selected: option.value === dataValue }"
        class="choice"
        @click="handleClick(index)"
      >
        <div>
          {{ option.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'dropdown-select',

  directives: {
    ClickOutside,
  },

  props: {
    options: {
      type: Array,
      required: true,
    },
    value: [String, Number, Boolean],
    queryNav: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dataValue: this.value,
      dataText: null,
      buttonActive: false,
    }
  },

  watch: {
    value() {
      this.dataValue = this.value
    },

    dataValue() {
      this.$emit('input', this.dataValue)
      this.dataText = this.options.find((option) => option.value === this.dataValue).text
      if(this.queryNav && this.$route.query.dataValue !== this.dataValue){
        this.$router.replace({query: {...this.$route.query, dataValue: this.dataValue}})
      }
    },
  },

  mounted() {
    this.dataText = this.options.find((option) => option.value === this.value).text
    if(this.queryNav && this.$route.query.dataValue){
      this.dataValue = this.$route.query.dataValue
    }
  },

  methods: {
    handleClick(index) {
      this.dataValue = this.options[index].value
      this.buttonActive = false
    },
    closeDropdown() {
      this.buttonActive = false
    },
    manageButton() {
      this.buttonActive = !this.buttonActive
      if (!this.buttonActive) {
        this.$emit('clickCancel')
      }
    },
  },
}
</script>

<style scoped></style>
